export default "__VITE_ASSET__HJWOtB_Y__"